var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "customerlist_div",
    staticStyle: {
      width: "100%",
      display: "flex",
      "flex-direction": "column"
    }
  }, [_c("div", [_c("a-card", {
    staticClass: "customerlistsearch_card",
    attrs: {
      bordered: false
    }
  }, [_c("div", {
    staticClass: "table-page-search-wrapper"
  }, [_c("a-form", {
    attrs: {
      layout: "inline"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.queryList.apply(null, arguments);
      }
    }
  }, [_c("a-row", {
    attrs: {
      gutter: 48
    }
  }, [_c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("customerList.customerInfo")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 50,
      allowClear: "",
      placeholder: _vm.$t("customerList.placeholder1")
    },
    model: {
      value: _vm.queryParam.customerInfo,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "customerInfo", $$v);
      },
      expression: "queryParam.customerInfo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("customerList.customerInfo2")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 100,
      allowClear: "",
      placeholder: _vm.$t("customerList.placeholder2")
    },
    model: {
      value: _vm.queryParam.erpCustomerInfo,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "erpCustomerInfo", $$v);
      },
      expression: "queryParam.erpCustomerInfo"
    }
  })], 1)], 1), _vm.advanced ? [_c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("customerList.dyxProductNo")
    }
  }, [_c("a-input-group", {
    staticStyle: {
      display: "flex"
    },
    attrs: {
      compact: ""
    }
  }, [_c("a-input", {
    staticStyle: {
      flex: "1 1 42%"
    },
    on: {
      blur: function blur($event) {
        return _vm.trimErpCustomerCodeZero("erpCustomerCodeStart");
      }
    },
    model: {
      value: _vm.queryParam.erpCustomerCodeStart,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "erpCustomerCodeStart", $$v);
      },
      expression: "queryParam.erpCustomerCodeStart"
    }
  }), _c("a-input", {
    staticStyle: {
      flex: "1 1 16%",
      "pointer-events": "none",
      backgroundColor: "#fff"
    },
    attrs: {
      placeholder: "~",
      disabled: ""
    }
  }), _c("a-input", {
    staticClass: "inputGroupOfRight",
    staticStyle: {
      flex: "1 1 42%"
    },
    on: {
      blur: function blur($event) {
        return _vm.trimErpCustomerCodeZero("erpCustomerCodeEnd");
      }
    },
    model: {
      value: _vm.queryParam.erpCustomerCodeEnd,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "erpCustomerCodeEnd", $$v);
      },
      expression: "queryParam.erpCustomerCodeEnd"
    }
  })], 1)], 1)], 1), _c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("customerList.approvalResult")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      "default-value": [0],
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    on: {
      change: _vm.handleChange
    },
    model: {
      value: _vm.queryParam.approvalResult,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "approvalResult", $$v);
      },
      expression: "queryParam.approvalResult"
    }
  }, _vm._l(_vm.AllStatus, function (item) {
    return _c("a-select-option", {
      key: item.key
    }, [_vm._v(" " + _vm._s(item.value) + " ")]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("customerList.registStatus")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      "default-value": ["0"],
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    on: {
      change: _vm.handleChange
    },
    model: {
      value: _vm.queryParam.registType,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "registType", $$v);
      },
      expression: "queryParam.registType"
    }
  }, _vm._l(_vm.AllStatus4, function (item) {
    return _c("a-select-option", {
      key: item.key
    }, [_vm._v(" " + _vm._s(item.value) + " ")]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("customer.registrationtime")
    }
  }, [_c("date-range", {
    on: {
      change: _vm.changeregistrationtimeDate
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("customerList.inviteCode")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 100,
      allowClear: "",
      placeholder: _vm.$t("customerList.placeholder3")
    },
    model: {
      value: _vm.queryParam.inviteCode,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "inviteCode", $$v);
      },
      expression: "queryParam.inviteCode"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("customerList.customerStatus3")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    on: {
      change: _vm.handleChange
    },
    model: {
      value: _vm.queryParam.payerInfo,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "payerInfo", $$v);
      },
      expression: "queryParam.payerInfo"
    }
  }, _vm._l(_vm.qingqiuxianList, function (item) {
    return _c("a-select-option", {
      key: item.key
    }, [_vm._v(" " + _vm._s(item.value) + " ")]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("customerList.customerStatus4")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    on: {
      change: _vm.handleChange
    },
    model: {
      value: _vm.queryParam.busFormatCode,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "busFormatCode", $$v);
      },
      expression: "queryParam.busFormatCode"
    }
  }, _vm._l(_vm.yetaiList, function (item) {
    return _c("a-select-option", {
      key: item.key
    }, [_vm._v(" " + _vm._s(item.value) + " ")]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("customerList.customerStatus5")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      mode: "multiple",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    on: {
      change: _vm.handleChange
    },
    model: {
      value: _vm.queryParam.sellerCode,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "sellerCode", $$v);
      },
      expression: "queryParam.sellerCode"
    }
  }, _vm._l(_vm.dandangzheList, function (item) {
    return _c("a-select-option", {
      key: item.key
    }, [_vm._v(" " + _vm._s(item.value) + " ")]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("customerList.importTimes")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      mode: "multiple",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    on: {
      change: _vm.handleChange
    },
    model: {
      value: _vm.queryParam.importversion,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "importversion", $$v);
      },
      expression: "queryParam.importversion"
    }
  }, _vm._l(_vm.importTimesList, function (item) {
    return _c("a-select-option", {
      key: item.key
    }, [_vm._v(" " + _vm._s(item.value) + " ")]);
  }), 1)], 1)], 1), _c("a-col", {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      md: _vm.advanced && 24 || 24,
      sm: 24
    }
  }, [_c("span", {
    staticClass: "table-page-search-submitButtons",
    style: _vm.advanced && {
      float: "right",
      overflow: "hidden"
    } || {}
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.queryList();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("publicuse.inquire2")) + " ")]), _c("a", {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      click: _vm.toggleAdvanced
    }
  }, [_vm._v(" " + _vm._s(_vm.advanced ? this.$t("publicuse.putaway") : this.$t("publicuse.unfold")) + " "), _c("a-icon", {
    attrs: {
      type: _vm.advanced ? "up" : "down"
    }
  })], 1)], 1)])] : _vm._e(), !_vm.advanced ? _c("a-col", {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      md: !_vm.advanced && 8 || 24,
      sm: 24
    }
  }, [_c("span", {
    staticClass: "table-page-search-submitButtons",
    style: _vm.advanced && {
      float: "right",
      overflow: "hidden"
    } || {}
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.queryList();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("publicuse.inquire2")) + " ")]), _c("a", {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      click: _vm.toggleAdvanced
    }
  }, [_vm._v(" " + _vm._s(_vm.advanced ? this.$t("publicuse.putaway") : this.$t("publicuse.unfold")) + " "), _c("a-icon", {
    attrs: {
      type: _vm.advanced ? "up" : "down"
    }
  })], 1)], 1)]) : _vm._e()], 2)], 1)], 1)])], 1), _c("div", {
    staticClass: "customercard_class",
    staticStyle: {
      "margin-top": "24px",
      position: "relative",
      flex: "1 1 0%"
    }
  }, [_c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("div", {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c("a-button", {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      loading: _vm.syncLoading
    },
    on: {
      click: _vm.syncDyx
    }
  }, [_vm._v(_vm._s(_vm.$t("customerList.customerSync")))]), _c("a-button", {
    attrs: {
      type: "primary",
      icon: "import"
    },
    on: {
      click: function click($event) {
        return _vm.importErp();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("customerList.import2")))]), _c("a-tooltip", {
    attrs: {
      placement: "topLeft",
      title: _vm.$t("customerList.placeholder4"),
      getPopupContainer: function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    }
  }, [_c("a-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      type: "info-circle"
    }
  })], 1)], 1), _c("a-table", {
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: function showTotal(total, range) {
          return "".concat(_vm.$t("public.total"), "\uFF1A") + _vm.listTotal;
        },
        current: _vm.queryParam.page,
        pageSize: _vm.queryParam.size,
        total: _vm.listTotal
      },
      id: "sorttableclass",
      rowKey: "id",
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.customerList
    },
    on: {
      change: _vm.tableChange
    },
    scopedSlots: _vm._u([{
      key: "customername",
      fn: function fn(text, record) {
        return _c("span", {}, [record.customerInfo ? _c("span", [_c("a-tooltip", [_c("template", {
          slot: "title"
        }, [record.customerInfo.customerEmail ? _c("span", [_vm._v(_vm._s(record.customerInfo.customerEmail))]) : _vm._e(), record.customerInfo.customerEmail && record.customerInfo.customerPhone ? _c("br") : _vm._e(), record.customerInfo.customerPhone ? _c("span", [_vm._v(_vm._s(record.customerInfo.customerPhone))]) : _vm._e(), record.customerInfo.customerEmail && record.customerInfo.note || record.customerInfo.customerPhone && record.customerInfo.note ? _c("br") : _vm._e(), record.customerInfo.note ? _c("span", [_vm._v(_vm._s(record.customerInfo.note))]) : _vm._e()]), record.customerInfo.customerEmail ? _c("span", [_vm._v(_vm._s(record.customerInfo.customerEmail))]) : _vm._e(), record.customerInfo.customerEmail && record.customerInfo.customerPhone ? _c("br") : _vm._e(), record.customerInfo.customerPhone ? _c("span", [_vm._v(_vm._s(record.customerInfo.customerPhone))]) : _vm._e(), record.customerInfo.customerEmail && record.customerInfo.note || record.customerInfo.customerPhone && record.customerInfo.note ? _c("br") : _vm._e(), record.customerInfo.note ? _c("span", [_vm._v(_vm._s(record.customerInfo.note))]) : _vm._e(), !record.customerInfo.customerEmail && !record.customerInfo.customerPhone ? _c("span", [_vm._v("--")]) : _vm._e()], 2)], 1) : _c("span", [_vm._v("--")])]);
      }
    }, {
      key: "approvalResult",
      fn: function fn(text, record) {
        return _c("span", {}, [record.customerInfo ? _c("a-tag", {
          attrs: {
            color: record.customerInfo.approvalResult == 2 ? "blue" : record.customerInfo.approvalResult == 3 ? "red" : "orange"
          }
        }, [_vm._v(_vm._s(record.customerInfo.approvalResult == 2 ? _vm.$t("customerList.pass") : record.customerInfo.approvalResult == 1 ? _vm.$t("customerList.approval") : _vm.$t("customerList.refuse")))]) : _c("span", [_vm._v("--")])], 1);
      }
    }, {
      key: "registTime",
      fn: function fn(text, record) {
        return _c("span", {}, [record.customerInfo && record.customerInfo.registType !== "" && record.customerInfo.registType !== null && record.customerInfo.registType !== undefined ? [_c("span", [record.customerInfo.registType == 1 ? [_vm._v(" " + _vm._s(_vm.$t("customerList.self")) + " ")] : record.customerInfo.registType == 2 ? [_vm._v(" " + _vm._s(_vm.$t("customerList.invite")) + " ")] : record.customerInfo.registType == 3 ? [_vm._v(" " + _vm._s(_vm.$t("customerList.backRegister")) + " ")] : [_vm._v(" " + _vm._s("--") + " ")]], 2), _c("br"), _c("span", [_vm._v(_vm._s(record.customerInfo.registTime))]), _c("br"), _c("span", [_vm._v(_vm._s(record.customerInfo.appinfo || "--"))])] : [_vm._v(" -- "), _c("br"), _vm._v(" -- "), _c("br"), _vm._v(" -- ")]], 2);
      }
    }, {
      key: "dyxMessage",
      fn: function fn(text, record) {
        return _c("span", {}, [record.erpCustomerCode ? _c("span", [_vm._v(_vm._s(record.erpCustomerCode))]) : _c("span", [_vm._v("--")]), _c("br"), _c("span", [_vm._v(_vm._s(record.erpCustomerName))])]);
      }
    }, {
      key: "erpCustomerPhone",
      fn: function fn(text, record) {
        return _c("span", {}, [record.erpCustomerPhone ? _c("span", [_c("span", [_vm._v(_vm._s(record.erpCustomerPhone))])]) : _c("span", [_vm._v("--")])]);
      }
    }, {
      key: "payerCode",
      fn: function fn(text, record) {
        return _c("span", {}, [record.payerCode ? _c("span", [_vm._v(_vm._s(record.payerCode))]) : _c("span", [_vm._v("--")])]);
      }
    }, {
      key: "sellerName",
      fn: function fn(text, record) {
        return _c("span", {}, [record.sellerName ? _c("span", [_vm._v(_vm._s(record.sellerName))]) : _c("span", [_vm._v("--")])]);
      }
    }, {
      key: "inviteCode",
      fn: function fn(text, record) {
        return _c("span", {}, [record.inviteCodeUsed ? _c("a", {
          on: {
            click: function click($event) {
              return _vm.openInvite(record);
            }
          }
        }, [_vm._v(_vm._s(record.inviteCodeUsed))]) : _c("span", [_vm._v("--")]), _c("br"), record.inviteCodeTotal ? _c("a", {
          on: {
            click: function click($event) {
              return _vm.openInvite(record);
            }
          }
        }, [_vm._v(_vm._s(record.inviteCodeTotal))]) : _c("span", [_vm._v("--")])]);
      }
    }, {
      key: "lastUpdateTime",
      fn: function fn(text, record) {
        return _c("span", {}, [record.lastUpdateTime ? _c("span", [_vm._v(_vm._s(record.lastUpdateTime))]) : _c("span", [_vm._v("--")])]);
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return _c("span", {}, [record.erpCustomerStatus !== 3 && record.customerInfo && (record.customerInfo.customerEmail != "" || record.customerInfo.customerPhone != "") ? _c("a", {
          on: {
            click: function click($event) {
              return _vm.updata(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("publicuse.edit")))]) : _c("a", {
          on: {
            click: function click($event) {
              return _vm.updata(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("customerList.editLook")))]), [_c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a-dropdown", {
          attrs: {
            trigger: ["click"]
          }
        }, [_c("a-menu", {
          attrs: {
            slot: "overlay"
          },
          slot: "overlay"
        }, [record.erpCustomerCode ? _c("a-menu-item", [_c("a", {
          on: {
            click: function click($event) {
              return _vm.openInvite(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("customerList.inviteCode")))])]) : _vm._e(), record.erpCustomerCode && record.erpCustomerStatus === _vm.ErpCustomerStatusTypes.NORMAL ? _c("a-menu-item", [_c("a", {
          on: {
            click: function click($event) {
              return _vm.addErpCustomer(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("customerList.addAccount")))])]) : _vm._e(), record.erpCustomerStatus !== 3 && record.customerInfo && record.customerInfo.approvalResult !== null && record.customerInfo.approvalResult !== undefined && record.customerInfo.approvalResult !== "" ? _c("a-menu-item", [_c("a", {
          on: {
            click: function click($event) {
              return _vm.changeNickname(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("customerList.updateUser")))])]) : _vm._e(), record.customerInfo && (record.customerInfo.customerEmail || record.customerInfo.customerPhone) ? _c("a-menu-item", [_c("a-popconfirm", {
          attrs: {
            title: _vm.$t("customerList.confirmDelErp"),
            "ok-text": _vm.$t("public.yes"),
            "cancel-text": _vm.$t("public.no")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.confirmDeleteCustomer(record);
            },
            cancel: _vm.cancelDeleteCustomer
          }
        }, [_c("a", [_vm._v(_vm._s(_vm.$t("customerList.delCustomer")))])])], 1) : _vm._e(), record.erpCustomerCode ? _c("a-menu-item", [_c("a", {
          on: {
            click: function click($event) {
              return _vm.delErpAndcustomer(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("customerList.delErp")))])]) : _vm._e(), record.customerInfo && record.customerInfo.approvalResult === 2 ? _c("a-menu-item", [_c("a", {
          on: {
            click: function click($event) {
              return _vm.loginFrontEnd(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("customer.loginfrontend")))])]) : _vm._e()], 1), _c("a", [_vm._v(_vm._s(_vm.$t("publicuse.more")) + " "), _c("a-icon", {
          attrs: {
            type: "down"
          }
        })], 1)], 1)]], 2);
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "inviteCodeTitle"
    },
    slot: "inviteCodeTitle"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("customerList.inviteUsed")))]), _c("br"), _c("span", [_vm._v(_vm._s(_vm.$t("customerList.inviteTotal")))])]), _c("span", {
    attrs: {
      slot: "timeTitle"
    },
    slot: "timeTitle"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("customerList.registStatus")))]), _c("br"), _c("span", [_vm._v(_vm._s(_vm.$t("customerList.registTime")))]), _c("br"), _c("span", [_vm._v(_vm._s(_vm.$t("customerList.appversion")))])])])], 1)], 1), _c("a-modal", {
    attrs: {
      title: _vm.$t("customerList.updateUser"),
      visible: _vm.visibleNickname
    },
    on: {
      cancel: _vm.handleCancelNickname
    }
  }, [_c("a-form-model", {
    ref: "nicknameForm",
    attrs: {
      model: _vm.nicknameForm,
      rules: _vm.rules
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.email"),
      prop: "email"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("customerList.placeholder5"),
      maxLength: 50
    },
    model: {
      value: _vm.nicknameForm.email,
      callback: function callback($$v) {
        _vm.$set(_vm.nicknameForm, "email", $$v);
      },
      expression: "nicknameForm.email"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.phone"),
      prop: "phone"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("customerList.placeholder5"),
      maxLength: 20
    },
    model: {
      value: _vm.nicknameForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.nicknameForm, "phone", $$v);
      },
      expression: "nicknameForm.phone"
    }
  })], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: _vm.handleCancelNickname
    }
  }, [_vm._v(_vm._s(_vm.$t("public.cancel")))]), _c("a-button", {
    attrs: {
      loading: _vm.confirmLoadingNicakname,
      type: "primary"
    },
    on: {
      click: _vm.handleOkNickname
    }
  }, [_vm._v(_vm._s(_vm.$t("public.confirm")))])], 1)], 2), _c("a-modal", {
    attrs: {
      title: _vm.$t("customerList.delErp"),
      visible: _vm.delerpVisible
    },
    on: {
      cancel: _vm.handleCanceldel
    }
  }, [_c("span", {
    staticStyle: {
      display: "inline-block",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t("customerList.customerInfo2")) + "：")]), _c("span", [_vm._v(_vm._s(this.erpCode + " " + this.erpName))]), _c("a-table", {
    attrs: {
      columns: _vm.columns2,
      "data-source": _vm.delErplist,
      pagination: false,
      loading: _vm.accountLoading
    },
    scopedSlots: _vm._u([{
      key: "dyxMessage",
      fn: function fn(text, record) {
        return _c("span", {}, [record.erpCustomerCode ? _c("span", [_vm._v(_vm._s(record.erpCustomerCode))]) : _c("span", [_vm._v("--")]), _c("br"), _c("span", [_vm._v(_vm._s(record.erpCustomerName))])]);
      }
    }, {
      key: "customername",
      fn: function fn(text, record) {
        return _c("span", {}, [record.customerEmail || record.customerPhone ? _c("span", [_c("a-tooltip", [_c("template", {
          slot: "title"
        }, [record.customerEmail ? _c("span", [_vm._v(_vm._s(record.customerEmail))]) : _vm._e(), record.customerEmail && record.customerPhone ? _c("br") : _vm._e(), record.customerPhone ? _c("span", [_vm._v(_vm._s(record.customerPhone))]) : _vm._e()]), record.customerEmail ? _c("span", [_vm._v(_vm._s(record.customerEmail))]) : _vm._e(), record.customerEmail && record.customerPhone ? _c("br") : _vm._e(), record.customerPhone ? _c("span", [_vm._v(_vm._s(record.customerPhone))]) : _vm._e(), !record.customerEmail && !record.customerPhone ? _c("span", [_vm._v("--")]) : _vm._e()], 2)], 1) : _c("span", [_vm._v("--")])]);
      }
    }, {
      key: "approvalResult",
      fn: function fn(text, record) {
        return _c("span", {}, [record.customerStatus ? _c("a-tag", {
          attrs: {
            color: record.customerStatus == 2 ? "blue" : record.customerStatus == 3 ? "red" : "orange"
          }
        }, [_vm._v(_vm._s(record.customerStatus == 2 ? _vm.$t("customerList.pass") : record.customerStatus == 1 ? _vm.$t("customerList.approval") : _vm.$t("customerList.refuse")))]) : _c("span", [_vm._v("--")])], 1);
      }
    }])
  }), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: _vm.handleCanceldel
    }
  }, [_vm._v(_vm._s(_vm.$t("public.cancel")))]), _c("a-button", {
    attrs: {
      loading: _vm.delerpLoading,
      type: "primary"
    },
    on: {
      click: _vm.handleDelete
    }
  }, [_vm._v(_vm._s(_vm.$t("public.confirm")))])], 1)], 2), _c("a-modal", {
    staticClass: "inviteMOdal",
    attrs: {
      width: 650,
      title: _vm.$t("customerList.inviteReg"),
      visible: _vm.visibleInvite
    },
    on: {
      cancel: _vm.handleCancelInvite
    }
  }, [_vm.inviteRegForm.regUrl ? _c("div", [_c("div", {
    staticStyle: {
      display: "flex",
      "line-height": "40px"
    }
  }, [_c("span", {
    staticStyle: {
      color: "rgba(0, 0, 0, 0.85)"
    },
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t("customerList.inviteRegUrl")))]), _c("a", {
    staticStyle: {
      "margin-left": "auto"
    },
    on: {
      click: _vm.copy
    }
  }, [_vm._v(_vm._s(_vm.$t("public.copy")))])]), _c("div", {
    attrs: {
      id: "copyInput"
    }
  }, [_c("div", [_vm._v(_vm._s(_vm.erpInviteContent1 + " " + _vm.erpCustomerName + " " + _vm.erpInviteContent2))]), _c("div", [_vm._v(_vm._s(_vm.erpInviteContent3))]), _c("div", {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.inviteRegForm.regUrl))])])]) : _vm._e(), _c("a-form-model", {
    ref: "inviteForm",
    attrs: {
      model: _vm.inviteRegForm,
      rules: _vm.inviteRules
    }
  }, [_c("div", {
    staticStyle: {
      color: "rgba(0, 0, 0, 0.85)"
    }
  }, [_vm._v(_vm._s(_vm.$t("customerList.emialNotice")))]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.erpCustomerEmail"),
      prop: "email"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      width: "100%"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("customerList.placeholder5"),
      maxLength: 50
    },
    model: {
      value: _vm.inviteRegForm.email,
      callback: function callback($$v) {
        _vm.$set(_vm.inviteRegForm, "email", $$v);
      },
      expression: "inviteRegForm.email"
    }
  }), _c("a-button", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      loading: _vm.sendLoading,
      disabled: _vm.inviteRegForm.email ? false : true,
      type: "primary"
    },
    on: {
      click: _vm.sendEmail
    }
  }, [_vm._v(_vm._s(_vm.$t("customer.sendout")))])], 1)]), _c("div", {
    staticStyle: {
      color: "rgba(0, 0, 0, 0.85)"
    }
  }, [_vm._v(_vm._s(_vm.$t("customerList.phoneNotice")))]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.erpCustomerPhone"),
      prop: "phone"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      width: "100%"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("customerList.placeholder5"),
      maxLength: 50
    },
    model: {
      value: _vm.inviteRegForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.inviteRegForm, "phone", $$v);
      },
      expression: "inviteRegForm.phone"
    }
  }), _c("a-button", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      loading: _vm.sendLoadingPhone,
      disabled: _vm.inviteRegForm.phone ? false : true,
      type: "primary"
    },
    on: {
      click: _vm.sendPhone
    }
  }, [_vm._v(_vm._s(_vm.$t("customer.sendout")))])], 1)])], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: _vm.handleCancelInvite
    }
  }, [_vm._v(_vm._s(_vm.$t("public.cancel")))])], 1)], 2), _c("a-modal", {
    attrs: {
      visible: _vm.visibleImport,
      footer: null,
      width: "700px"
    },
    on: {
      cancel: _vm.handleCancelImport
    }
  }, [_c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t("customerList.importMsg2"))), _c("a", {
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      click: _vm.downloadImport
    }
  }, [_vm._v(_vm._s(_vm.$t("customerList.importMsg3")))]), _vm._v(_vm._s(_vm.$t("customerList.importMsg4")))]), _c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("customerList.importMsg5")))]), _c("div", {
    staticStyle: {
      "text-align": "center",
      "margin-top": "50px"
    }
  }, [_c("a-upload", {
    attrs: {
      action: _vm.action,
      multiple: false,
      showUploadList: false,
      "before-upload": _vm.beforeUpload,
      headers: _vm.newheaders,
      limit: 1
    },
    on: {
      change: _vm.handleChangeImport
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      icon: "import"
    },
    on: {
      click: _vm.handleOkImport
    }
  }, [_vm._v(_vm._s(_vm.$t("customerList.import")))])], 1)], 1)]), _c("a-modal", {
    attrs: {
      title: _vm.$t("customerList.importResultTitle"),
      visible: _vm.errorVisible,
      width: "700px",
      footer: null
    },
    on: {
      cancel: _vm.handleCancelErrorErp
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t("customerList.success", {
    num1: _vm.suucessNum,
    num2: _vm.errorNum,
    num3: _vm.importNum
  })) + " ")]), this.errorNum > 0 ? _c("a-table", {
    attrs: {
      pagination: false,
      columns: _vm.importColumns,
      "data-source": _vm.importData,
      "row-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "dyxName",
      fn: function fn(text, record) {
        return _c("span", {}, [record.erpCustomerName ? _c("span", [_vm._v(_vm._s(record.erpCustomerName))]) : _c("span", [_vm._v("--")])]);
      }
    }, {
      key: "number",
      fn: function fn(text, record) {
        return _c("span", {}, [record.erpCustomerCode ? _c("span", [_vm._v(_vm._s(record.erpCustomerCode))]) : _c("span", [_vm._v("--")])]);
      }
    }], null, false, 2139787496)
  }) : _vm._e()], 1), _c("a-modal", {
    attrs: {
      title: _vm.$t("customerList.newAccountTitle"),
      visible: _vm.newAccountModalVisible
    },
    on: {
      cancel: _vm.handleCancelNewAccount
    }
  }, [_c("div", [_c("a-alert", {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      message: _vm.$t("customerList.placeEmailOrPhonetip"),
      description: "",
      type: "warning",
      "show-icon": ""
    }
  })], 1), _c("a-form-model", {
    ref: "newAccountForm",
    staticClass: "newAccountForm",
    attrs: {
      model: _vm.newAccountForm,
      rules: _vm.newAccountFormRules
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.phone"),
      prop: "phone"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("customerList.placeholder5"),
      maxLength: 20
    },
    model: {
      value: _vm.newAccountForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.newAccountForm, "phone", $$v);
      },
      expression: "newAccountForm.phone"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.email"),
      prop: "email"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("customerList.placeholder5"),
      maxLength: 50
    },
    model: {
      value: _vm.newAccountForm.email,
      callback: function callback($$v) {
        _vm.$set(_vm.newAccountForm, "email", $$v);
      },
      expression: "newAccountForm.email"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.tmpPwd"),
      prop: "tempPwd"
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 20
    },
    model: {
      value: _vm.newAccountForm.tempPwd,
      callback: function callback($$v) {
        _vm.$set(_vm.newAccountForm, "tempPwd", $$v);
      },
      expression: "newAccountForm.tempPwd"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.remark"),
      prop: "note"
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 20
    },
    model: {
      value: _vm.newAccountForm.note,
      callback: function callback($$v) {
        _vm.$set(_vm.newAccountForm, "note", $$v);
      },
      expression: "newAccountForm.note"
    }
  })], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: _vm.handleCancelNewAccount
    }
  }, [_vm._v(_vm._s(_vm.$t("public.cancel")))]), _c("a-button", {
    attrs: {
      loading: _vm.confirmLoadingNewAccount,
      type: "primary"
    },
    on: {
      click: _vm.handleOkNewAccount
    }
  }, [_vm._v(_vm._s(_vm.$t("public.confirm")))])], 1)], 2), _c("div", {
    ref: "drawer"
  }, [_c("a-drawer", {
    attrs: {
      title: _vm.$t("customerList.inviteCode"),
      placement: "right",
      closable: true,
      visible: _vm.drawerVisible,
      "after-visible-change": _vm.afterVisibleChange,
      width: 900,
      zIndex: 10
    },
    on: {
      close: _vm.drawerClose
    }
  }, [_c("a-descriptions", [_c("a-descriptions-item", {
    attrs: {
      label: _vm.$t("customerList.customerInfo2")
    }
  }, [_c("span", [_vm._v(_vm._s(this.inviteDrawForm.erpCustomerCode + " " + this.inviteDrawForm.erpCustomerName))])])], 1), _c("a-form-model", {
    ref: "bindVisible",
    attrs: {
      layout: "horizontal"
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      display: "flex"
    },
    attrs: {
      label: _vm.$t("customerList.inviteCount")
    }
  }, [_c("a-input-number", {
    attrs: {
      id: "inputNumber",
      min: 1,
      max: 100
    },
    model: {
      value: _vm.inviteDrawForm.inviteCount,
      callback: function callback($$v) {
        _vm.$set(_vm.inviteDrawForm, "inviteCount", $$v);
      },
      expression: "inviteDrawForm.inviteCount"
    }
  }), _c("a-button", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      type: "primary",
      loading: _vm.newInviteLoading
    },
    on: {
      click: _vm.newInvite
    }
  }, [_vm._v(_vm._s(_vm.$t("customerList.newInvite")))])], 1)], 1), _c("a-table", {
    attrs: {
      pagination: false,
      columns: _vm.drawcolumns,
      "data-source": _vm.drawdata,
      rowKey: "id",
      loading: _vm.inviteTableLoading
    },
    scopedSlots: _vm._u([{
      key: "invite",
      fn: function fn(text, record, index) {
        return _c("span", {}, [_vm._v(" " + _vm._s(record.inviteCode) + " ")]);
      }
    }, {
      key: "status",
      fn: function fn(text, record, index) {
        return _c("span", {}, [record.status === 1 ? _c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(_vm._s(_vm.$t("customerList.used")))]) : _c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(_vm._s(_vm.$t("customerList.noused")))])], 1);
      }
    }, {
      key: "userInfo",
      fn: function fn(text, record, index) {
        return _c("span", {}, [_c("a-tooltip", [_c("template", {
          slot: "title"
        }, [record.customerInfo && record.customerInfo.customerEmail ? _c("div", [_vm._v(_vm._s(record.customerInfo.customerEmail))]) : _vm._e(), record.customerInfo && record.customerInfo.customerPhone ? _c("div", [_vm._v(_vm._s(record.customerInfo.customerPhone))]) : _vm._e(), record.customerInfo && record.customerInfo.registDate ? _c("div", [_vm._v(_vm._s(record.customerInfo.registDate))]) : _vm._e()]), record.customerInfo ? _c("a", {
          on: {
            click: function click($event) {
              return _vm.inviteToEdit(record);
            }
          }
        }, [record.customerInfo.customerEmail ? _c("div", {
          staticClass: "line-1"
        }, [_vm._v(_vm._s(record.customerInfo.customerEmail))]) : _vm._e(), record.customerInfo.customerPhone ? _c("div", {
          staticClass: "line-1"
        }, [_vm._v(_vm._s(record.customerInfo.customerPhone))]) : _vm._e(), record.customerInfo.registDate ? _c("div", {
          staticClass: "line-1"
        }, [_vm._v(_vm._s(record.customerInfo.registDate))]) : _vm._e()]) : _c("div", [_vm._v(" -- ")])], 2)], 1);
      }
    }, {
      key: "remark",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("EditableCell", {
          attrs: {
            text: record.remark
          },
          on: {
            change: function change(value) {
              return _vm.saveInviteRemark(value, record.id);
            }
          }
        })], 1);
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return _c("span", {}, [record.status !== 1 ? _c("div", [_c("a", {
          on: {
            click: function click($event) {
              return _vm.handleInviteRegister(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("customerList.inviteReg")))]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("customerList.confirmDelErp"),
            "ok-text": _vm.$t("public.yes"),
            "cancel-text": _vm.$t("public.no")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.confirmDeleteInvite(record);
            },
            cancel: function cancel($event) {}
          }
        }, [_c("a", {
          attrs: {
            href: ""
          }
        }, [_vm._v(_vm._s(_vm.$t("publicuse.delete")))])])], 1) : _c("div", [_vm._v("--")])]);
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "customerInfoTitle"
    },
    slot: "customerInfoTitle"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("customerList.customerInfo")))]), _c("br"), _c("span", [_vm._v(_vm._s(_vm.$t("customerList.registTime")))])])])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };